import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { prepareValidationForAppwrite } from './common/common_utils';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import ParentCardNoHeader from '../common/ParentCardNoHeader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class AppwriteDataSourceCreate extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  handleSendRequset = async (values) => {
    const { appwriteProjectid, appwriteAPIKey, appwriteHostedUrl, dataSourceName } = values;
    const { actions, match, history } = this.props;
    const { projectId, version } = match.params;
    const settingData = {
      'X-Appwrite-Project': appwriteProjectid,
      'X-Appwrite-Key': appwriteAPIKey,
      hostedUrl: appwriteHostedUrl ? appwriteHostedUrl : '',
    };
    if (appwriteProjectid && appwriteAPIKey && dataSourceName) {
      await actions.getDatabasesForAppwrite({ projectId, settingData, version });

      if (this.props.dataConnector.databaseByAppwrite) {
        history.push(`/data-connector/${version}/v/${projectId}/appwrite-datasource/list`, {
          settingData,
          dataSourceName,
        });
      }
    }
  };

  handleCancel = () => {
    const { match, history } = this.props;
    const { projectId, version } = match.params;
    history.push(`/collections/${version}/v/${projectId}/create`);
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }

    const { dataConnector } = this.props;
    const { getDatabasesForAppwritePending } = dataConnector;
    return (
      <CommonPageComponent>
        <ParentContentCard title="Create Collection via Appwrite" datasourceIconSvg="Appwrite">
          <Formik
            initialValues={{
              dataSourceName: '',
              appwriteProjectid: '',
              appwriteAPIKey: '',
              appwriteHostedUrl: '',
            }}
            validationSchema={prepareValidationForAppwrite}
            onSubmit={this.handleSendRequset}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Name"
                    icon="text"
                    infoIcon={true}
                    infoDescription={
                      'Enter name for the Data Source you want to create in drapcode.'
                    }
                  >
                    <Field
                      type="text"
                      name="dataSourceName"
                      className="form-control form-control-sm"
                      placeholder="Data Source Name"
                    />
                    <ErrorMessage name="dataSourceName" component="p" className="text-danger" />
                  </FormFieldWithLabel>
                </div>

                <ParentCardNoHeader title="Appwrite Account Details">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="ProjectId"
                      icon="text"
                      infoIcon={true}
                      infoDescription={
                        'Enter Appwrite Project ID.from your Appwrite account Project section. This ID is necessary for your application to interact with the Appwrite backend services.'
                      }
                    >
                      <Field
                        type="text"
                        name="appwriteProjectid"
                        className="form-control form-control-sm"
                        placeholder="ProjectId"
                      />
                      <ErrorMessage
                        name="appwriteProjectid"
                        component="p"
                        className="text-danger"
                      />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="API Key"
                      icon="text"
                      infoIcon={true}
                      infoDescription={
                        'Enter Appwrite API Key obtained from your Appwrite project settings. This key is essential for your application to securely communicate with the Appwrite backend services. Never share it publicly.'
                      }
                    >
                      <Field
                        type="text"
                        name="appwriteAPIKey"
                        className="form-control form-control-sm"
                        placeholder="API Key"
                      />
                      <ErrorMessage name="appwriteAPIKey" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Your own Hosted Url (Optional)"
                      icon="text"
                      infoIcon={true}
                      infoDescription={`Enter Your own Hosted Url if you have or want to use. It acts as the endpoint for accessing and managing your database resources.`}
                    >
                      <Field
                        type="text"
                        name="appwriteHostedUrl"
                        className="form-control form-control-sm"
                        placeholder="Your own Hosted Url if any (Optional)"
                      />
                      <ErrorMessage
                        name="appwriteHostedUrl"
                        component="p"
                        className="text-danger"
                      />
                    </FormFieldWithLabel>
                  </div>
                </ParentCardNoHeader>

                <div className="clearfix">
                  <button
                    className="btn btn-outline-secondary"
                    title="Cancel"
                    type="button"
                    onClick={this.handleCancel}
                  >
                    <i className="wb webconnect-times"></i> Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-theme-submit float-right"
                    disabled={isSubmitting || getDatabasesForAppwritePending}
                  >
                    <i className="wb webconnect-rocket"></i> &nbsp;Continue&nbsp;
                    <CustomLoader loading={getDatabasesForAppwritePending}></CustomLoader>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppwriteDataSourceCreate);
